import axios from "~/plugins/axios";

export default {
  getDefaultSourcesByInvitationType(invitationType) {
    return axios.get('/web_api/v1/aqopi_sources/default_by_invitation_type/' + invitationType).then((response) => response.data);
  },
  getAvailableSourcesByInvitationType(invitationType) {
    return axios.get('/web_api/v1/aqopi_sources/available_by_invitation_type/' + invitationType).then((response) => response.data);
  }
};
